let moment = require('../../libs/moment');
let _ = require('../../libs/lodash');

/**
 * Date Range Extractor
 * Handles retrieving all the weekdays of a given date range
 */
class DateRangeExtractor {

    /**
     * Return an array of weekdays based on the date range provided
     * Throws an exception if the start date is greater than the end date
     * 
     * @param {string} dateFrom - Start date range
     * @param {string} dateTo   - End date range
     * 
     * @return {Array}
     */
    getWeekdays (dateFrom, dateTo) {

        let range      = this._validateDates(dateFrom, dateTo),
            currentDay = range.currentDay,
            lastDay    = range.lastDay,
            weekdays   = [];

            
        if (dateFrom === dateTo && 
            this._isWeekday(currentDay)) {
            return [currentDay];
        }

        while (!currentDay.isSame(lastDay)) {
            if (this._isWeekday(currentDay)) {
                weekdays.push(currentDay.clone());
            }

            currentDay = currentDay.add(1, 'days');
        }

        return weekdays;
    }

    /**
     * Return a marked dates based on range.
     * It marks all Fridays, and changes on the month
     *  
     * @param {array} dates - Array of dates
     */
    addMarkings(dates) {

        let monthMarkings  = [];
        let fridayMarkings = [];

        // let's assume we are starting on a new month
        let isSameMonth    = false;

        _.each(dates, (day, i) => {
            // Check if it's friday
            let isFriday = day.weekday() === 5;
            let currentMonth = day.format('MM')
            
            // Check if the previous day is from a different month
            if (i > 0) {
                let previousMonth = dates[i - 1].format('MM');
                isSameMonth = (currentMonth === previousMonth);
            }
            
            fridayMarkings.push(isFriday);
            monthMarkings.push((!isSameMonth) ? day.format('MMMM') : '');
        });

        return {
            dates    : dates,
            weekEnds : fridayMarkings,
            months   : monthMarkings
        }
    }
    
    /**
     * Return true if the current day is a weekday, false otherwise
     * 
     * @param {moment} day Day to evaluate
     * 
     * @returns {boolean}
     */
    _isWeekday(day) {
        day = day.weekday();
        return (day < 6 && day > 0);
    }

    /**
     * Validate date range input
     * 
     * @param {string} dateFrom - Start date range
     * @param {string} dateTo   - End date range
     */
    _validateDates(dateFrom, dateTo) {

        // dates are not null
        if (dateFrom == null || dateTo == null) {
            throw "Dates not provided";
        }
        
        // Make sure dates are valid
        if (_.isNaN(Date.parse(dateFrom)) || _.isNaN(Date.parse(dateTo))) {
            throw "Invalid dates provided";
        }

        let currentDay = moment(dateFrom),
            lastDay    = moment(dateTo).add(1, 'days');

        // Current day should not be greater than the last day
        if (currentDay.isAfter(lastDay)) {
            throw "Invalid date range";
        }

        return {currentDay, lastDay};
    }

}

module.exports = DateRangeExtractor;